import React from 'react';
import { default as ReactSelect } from 'react-select';
import { ISelect } from 'src/components/Select/Select.i';
import { InputError } from '@riac/design-system';
import { RequiredStar } from 'src/components/Input/Input.style';
import styled from 'styled-components';
import { ReactSelectLabel } from 'src/components/Select/Select.style';


const UnstyledSelect = ({ label, inline, error, backgroundColor, inverted, noBorder, required, disabled, ...props }: ISelect) => {
  return (
    <ReactSelectContainer>
      <ReactSelectLabel
        inline={inline}
        className={props.className}
        backgroundColor={backgroundColor}
        inverted={inverted}
        noBorder={noBorder}
      >
        {label && <span>{label}</span> || ''}
        {required
            && <>{' '}<RequiredStar>*</RequiredStar></>
        }
        <ReactSelect {...props} className='react-select' isDisabled={disabled} classNamePrefix='react-select'/>
        <InputError error={error}/>
      </ReactSelectLabel>
    </ReactSelectContainer>
  );
};

export const Select = styled(UnstyledSelect)`
  margin-top: 10px;
`;

export const ReactSelectContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  margin: 0;
  width: 100%;
`;
